/**
 * SODECO - Image catalog
 * --------------------------------------------------------------
 * Replace any URL here with your own asset (upload to /public or
 * paste a remote URL). The whole site reads images from this file
 * so you only need to edit ONE place.
 * --------------------------------------------------------------
 */

export const images = {
  // Hero on Home (full-bleed). Provide a wide, dignified humanitarian image.
  heroHome:
    "https://images.unsplash.com/photo-1509099836639-18ba1795216d?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",

  // Small "encyclopedia" images for the Home foundation story (4 slots).
  encyclopedia: [
    {
      src: "https://res.cloudinary.com/djrrgpbxy/image/upload/f_auto/q_auto/dpr_auto/voluntier_jc3qhs",
      caption_en: "First volunteers, 2008",
      caption_es: "Primeros voluntarios, 2008",
    },
    {
      src: "https://res.cloudinary.com/djrrgpbxy/image/upload/f_auto/q_auto/dpr_auto/voluntier3_wpvnin",
      caption_en: "Community of women, La Guajira",
      caption_es: "Comunidad de mujeres, La Guajira",
    },
    {
      src: "https://res.cloudinary.com/djrrgpbxy/image/upload/f_auto/q_auto/dpr_auto/pjublico_pih8fw",
      caption_en: "Headquarters, founding district",
      caption_es: "Sede central, distrito fundacional",
    },
    {
      src: "https://res.cloudinary.com/djrrgpbxy/image/upload/f_auto/q_auto/dpr_auto/mule_tizet7",
      caption_en: "Field medical brigade",
      caption_es: "Brigada médica en campo",
    },
  ],

  // Decorative wide image used inside the encyclopedia split section.
  encyclopediaWide:
    "https://res.cloudinary.com/djrrgpbxy/image/upload/f_auto/q_auto/dpr_auto/dd_yslnwx",

  // Contact page header.
  contactHeader:
    "https://images.unsplash.com/photo-1653575287854-8e77cb952eb7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",

  // Missions page header (above the timeline).
  missionsHeader:
    "https://images.unsplash.com/photo-1777407544381-d96aa24b4725?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",

  /**
   * Circular logo / brand mark used next to the "SODECO" text in the
   * header and footer. Replace this URL with your own logo or photo.
   * Recommended: square image (1:1), at least 200x200 px, transparent
   * background (PNG) or any photo (will be cropped to a circle).
   */
  logoMark:
    "https://res.cloudinary.com/djrrgpbxy/image/upload/q_auto/WhatsApp_Image_2026-05-16_at_01.53.46_cizqvp",

  /**
   * Testimonials (avatars). Square portraits, 1:1 ratio.
   * Edit content.js → home.testimonials to change names and quotes.
   */
  testimonials: [
    "https://res.cloudinary.com/djrrgpbxy/image/upload/f_auto/q_auto/dpr_auto/testimonio_3_zmi2jf",
    "https://res.cloudinary.com/djrrgpbxy/image/upload/f_auto/q_auto/dpr_auto/testimonio_2_hmppdg",
    "https://res.cloudinary.com/djrrgpbxy/image/upload/f_auto/q_auto/dpr_auto/Testimonio_1_q9pzs4",
  ],

  /**
   * Impact in the Dominican Republic — small images that follow the
   * same margin style as the encyclopedia section.
   */
  dominicanRepublic: [
    {
      src: "https://res.cloudinary.com/dv8quznfv/image/upload/v1782268213/WhatsApp_Image_2026-05-15_at_23.50.11_qtpapi.jpg",
      caption_es: "Zona Rural, Barahona",
      caption_en: "Rural Zone, Barahona",
    },
    {
      src: "https://res.cloudinary.com/dv8quznfv/image/upload/v1782268332/WhatsApp_Image_2026-05-15_at_23.50.13_1_ld7qy0.jpg",
      caption_es: "Costas del Caribe",
      caption_en: "Caribbean coastline",
    },
    {
      src: "https://res.cloudinary.com/dv8quznfv/image/upload/v1782268292/WhatsApp_Image_2026-05-15_at_23.50.13_zdjwox.jpg",
      caption_es: "Comunidad de Higüey",
      caption_en: "Higüey community",
    },
    {
      src: "https://res.cloudinary.com/dv8quznfv/image/upload/v1782268393/WhatsApp_Image_2026-05-15_at_23.50.13_2_afmjzn.jpg",
      caption_es: "Brigada de salud, Santiago",
      caption_en: "Health brigade, Santiago",
    },
  ],

  /**
   * Staff — circular portrait icons used in the hierarchy section at
   * the bottom of the Home page. Edit content.js → home.staff to
   * change names and roles. Order in array matches order in content.
   */
  staff: {
    ceo: "https://res.cloudinary.com/djrrgpbxy/image/upload/f_auto/q_auto/dpr_auto/presidentr2_t0ytgr",
    executiveDirector:
      "https://res.cloudinary.com/djrrgpbxy/image/upload/f_auto/q_auto/dpr_auto/juan_martine_ajr4pk",
    managers: [
      "https://res.cloudinary.com/djrrgpbxy/image/upload/f_auto/q_auto/dpr_auto/manager.1_dqco4k",
      "https://res.cloudinary.com/djrrgpbxy/image/upload/f_auto/q_auto/dpr_auto/manager1_mhdbwo",
      "https://res.cloudinary.com/djrrgpbxy/image/upload/f_auto/q_auto/dpr_auto/WhatsApp_Image_2026-05-18_at_20.15.33_rlx9ma",
    ],
    supervisors: [
      "https://res.cloudinary.com/dv8quznfv/image/upload/v1780433558/WhatsApp_Image_2026-05-20_at_01.40.52_cveave.jpg",
      "https://res.cloudinary.com/dv8quznfv/image/upload/v1780433228/WhatsApp_Image_2026-05-20_at_01.40.59_l4tdsp.jpg",
      "https://res.cloudinary.com/dv8quznfv/image/upload/v1780433676/WhatsApp_Image_2026-05-20_at_01.40.53_diq1mf.jpg",
      "https://res.cloudinary.com/dv8quznfv/image/upload/v1780433900/WhatsApp_Image_2026-05-20_at_22.28.42_buryak.jpg",
    ],
    specialists: [
      "https://res.cloudinary.com/djrrgpbxy/image/upload/f_auto/q_auto/dpr_auto/sup1_ezfs15",
      "https://res.cloudinary.com/djrrgpbxy/image/upload/f_auto/q_auto/dpr_auto/sup3_konwi7",
      "https://res.cloudinary.com/djrrgpbxy/image/upload/f_auto/q_auto/dpr_auto/sup2_gu7juk",
      "https://res.cloudinary.com/dv8quznfv/image/upload/v1780434665/image_iifuyn.jpg",
      "https://res.cloudinary.com/dv8quznfv/image/upload/v1780434796/WhatsApp_Image_2026-05-20_at_22.28.41_wqywpu.jpg",
      "https://res.cloudinary.com/dv8quznfv/image/upload/v1780434961/WhatsApp_Image_2026-05-20_at_22.28.43_inqkgd.jpg",
    ],
  },
};

export default images;
